module.exports = __webpack_public_path__ + "img/status-promotion.f4dab290.png";